/* eslint-disable  */
import client from '@/http/client';

const BASE_URL = '/notifications';

class NotificationsCenter {
  socket = null;

  getNotifications() {
    return client.get(`${BASE_URL}/`, {
      params: {
        limit: 100,
      },
    });
  }

  readNotifications(notifications) {
    return client.post(`${BASE_URL}/read/`, { all: false, notifications });
  }

  readAllNotifications() {
    return client.post(`${BASE_URL}/read/`, { all: true });
  }
}

export default new NotificationsCenter();
